import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ErzeugungsanlageListComponent } from './erzeugungsanlage-list/erzeugungsanlage-list.component';
import { ErzeugungsanlagePageComponent } from './erzeugungsanlage-page/erzeugungsanlage-page.component';
import { MaterialModule } from '../common/material/material.module';
import { ServiceModule } from '../service/service.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErzeugungsanlageRoutingModule } from './erzeugungsanlage-routing.module';
import { ErzeugungsanlageTileComponent } from './erzeugungsanlage-tile/erzeugungsanlage-tile.component';
import { ErzeugungsanlageTableComponent } from './erzeugungsanlage-table/erzeugungsanlage-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErzeugungsanlageTileViewComponent } from './erzeugungsanlage-tile-view/erzeugungsanlage-tile-view.component';
import { GlobalDirectivesModule } from '../common/form/validation/global-directives.module';
import { ErzeugungsanlageFilterComponent } from './erzeugungsanlage-filter/erzeugungsanlage-filter.component';
import { PipeModule } from '../common/pipe/pipe.module';
import { ErzeugungsanlageDetailComponent } from './erzeugungsanlage-detail/erzeugungsanlage-detail.component';
import { ErzeugungsanlageFormModule } from './erzeugungsanlage-form/erzeugungsanlage-form.module';
import { FormComponentsModule } from '../common/form/components/form-components.module';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({ declarations: [
    ErzeugungsanlageListComponent,
    ErzeugungsanlageTileViewComponent,
    ErzeugungsanlagePageComponent,
    ErzeugungsanlageTileComponent,
    ErzeugungsanlageTableComponent,
    ErzeugungsanlageFilterComponent,
    ErzeugungsanlageDetailComponent,
],
exports: [
    ErzeugungsanlageDetailComponent,
], imports: [
    CommonModule,
    MaterialModule,
    ServiceModule,
    ErzeugungsanlageRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    GlobalDirectivesModule,
    PipeModule,
    ErzeugungsanlageFormModule,
    FormComponentsModule,
    MatIconModule,
    MatBadgeModule,
    NgOptimizedImage,
], providers: [
    provideHttpClient(withInterceptorsFromDi()),
] })
export class ErzeugungsanlageModule {
}
